import { z } from 'zod';
import { APP_CONSTRAINTS } from '@/lib/constants/app';

export const appWebFormSchema = z.object({
  customDomain: z.string().max(APP_CONSTRAINTS.CUSTOM_DOMAIN_MAX),
  styleIsDarkMode: z.boolean(),
  styleBGColorHex: z.string(),
  styleTextColorHex: z.string(),
  allowIndex: z.boolean(),
  appStateTypeId: z.number(),
});

export type AppWebFormSchemaData = z.infer<typeof appWebFormSchema>;
